<script>
    export let data;
    import { marked } from "marked";
    import DelegateButton from "./DelegateButton.svelte";
    import DeferButton from "./DeferButton.svelte";
    import DoButton from "./DoButton.svelte";
    import DiscardButton from "./DiscardButton.svelte";
    import SomeDayButton from "./SomeDayButton.svelte";
    import ConvertProjectButton from "./ConvertProjectButton.svelte";
    import AddToProjectButton from "./AddToProjectButton.svelte";
    import { updateTask } from "../store";

    let cardUpdated = false;

    //Edit Name
    let editable = false;
    let name = data.name;

    function handleDblClick(event) {
        editable = true; // or use  editable=!editable  to toggle
    }

    //Edit Description
    let description = data.description;
    let editDescription = false;

    function handleDblClickDescription(event) {
        editDescription = true;
    }


    function textUpdated() {
        cardUpdated = true;
    }

    function updateCard() {
        data.name = name;
        data.description = description;
        data = data;
        cardUpdated = false;
        updateTask(data);
    }
</script>

<div class="col-md-4 py-2">
    <div class="card" style="width: 18rem;">
        <div class="card-block h-100">
            <div class="card-body">
                <h5 class="card-title">
                    <div
                        on:dblclick={handleDblClick}
                        class={editable ? "edit-mode" : "read-mode"}
                        on:keydown={textUpdated}
                        contenteditable={editable}
                    >
                        {data.name}
                    </div>
                </h5>
                <p class="card-text">
                    <div
                        on:dblclick={handleDblClickDescription}
                        class={editDescription ? "edit-mode" : "read-mode"}
                        on:keydown={textUpdated}
                        contenteditable={editDescription}
                    > 
                    {@html marked(description)}
                    </div>
                
                <p class="white-space: nowrap;">
                    <DoButton bind:data />
                    <DelegateButton bind:data />
                    <DeferButton bind:data />
                    <SomeDayButton bind:data />
                    <ConvertProjectButton bind:data />
                    <AddToProjectButton bind:data />
                    <DiscardButton bind:data />
                </p>
            </div>
        </div>
    </div>
</div>

<style>
    .card {
        width: 23rem;
        height: 39 rem;
        max-height: 39rem;
    }
</style>
